import { type ERoom, type TNumberInputs } from 'shared/types/filter';
import { type ITypedReduxAction } from 'shared/types/redux/actionType';
import { type TThunkAction } from 'shared/types/redux/thunk';

import { residentialComplexesIdsChange } from '../residentialComplexesIds';
import { specialPromosBlocksRefresh } from '../specialPromosBlocks';

export enum EFilterActionTypes {
  RegionChange = 'FILTER/REGION_CHANGE',
  RoomsChange = 'FILTER/ROOMS_CHANGE',
  MinPriceChange = 'FILTER/MIN_PRICE_CHANGE',
  MaxPriceChange = 'FILTER/MAX_PRICE_CHANGE',
  MinAreaChange = 'FILTER/MIN_AREA_CHANGE',
  MaxAreaChange = 'FILTER/MAX_AREA_CHANGE',
  DeadlineChange = 'FILTER/DEADLINE_CHANGE',
  DeadlineVariantsChange = 'FILTER/DEADLINE_VARIANTS_CHANGE',
  ReadyApartmentChange = 'FILTER/READY_APARTMENT_CHANGE',
  ApartmentWithDecorationChange = 'FILTER/APARTMENT_WITH_DECORATION_CHANGE',
  SeriaPlusChange = 'FILTER/SERIA_PLUS_CHANGE',
}

export type TRegionChange = ITypedReduxAction<EFilterActionTypes.RegionChange, number>;
export type TRoomsChange = ITypedReduxAction<EFilterActionTypes.RoomsChange, ERoom[]>;
export type TMinPriceChange = ITypedReduxAction<EFilterActionTypes.MinPriceChange, TNumberInputs>;
export type TMaxPriceChange = ITypedReduxAction<EFilterActionTypes.MaxPriceChange, TNumberInputs>;
export type TMinAreaChange = ITypedReduxAction<EFilterActionTypes.MinAreaChange, TNumberInputs>;
export type TMaxAreaChange = ITypedReduxAction<EFilterActionTypes.MaxAreaChange, TNumberInputs>;
export type TDeadlineChange = ITypedReduxAction<EFilterActionTypes.DeadlineChange, TNumberInputs>;
export type TDeadlineVariantsChange = ITypedReduxAction<EFilterActionTypes.DeadlineVariantsChange, number[]>;
export type TReadyApartmentChange = ITypedReduxAction<EFilterActionTypes.ReadyApartmentChange, boolean>;
export type TApartmentWithDecorationChange = ITypedReduxAction<
  EFilterActionTypes.ApartmentWithDecorationChange,
  boolean
>;
export type TSeriaPlusChange = ITypedReduxAction<EFilterActionTypes.SeriaPlusChange, boolean>;

export type TFilterActions =
  | TRegionChange
  | TRoomsChange
  | TMinPriceChange
  | TMaxPriceChange
  | TMinAreaChange
  | TMaxAreaChange
  | TDeadlineChange
  | TDeadlineVariantsChange
  | TReadyApartmentChange
  | TSeriaPlusChange
  | TApartmentWithDecorationChange;

export function regionChange(region: number): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();
    dispatch(residentialComplexesIdsChange({ ...filter, location: region }));
    dispatch({ payload: region, type: EFilterActionTypes.RegionChange });
    dispatch(specialPromosBlocksRefresh(region));
  };
}
export function roomsChange(rooms: ERoom[]): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, rooms }));
    dispatch({ payload: rooms, type: EFilterActionTypes.RoomsChange });
  };
}
export function minPriceChange(minPrice: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, minPrice }));
    dispatch({ payload: minPrice, type: EFilterActionTypes.MinPriceChange });
  };
}
export function maxPriceChange(maxPrice: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, maxPrice }));
    dispatch({ payload: maxPrice, type: EFilterActionTypes.MaxPriceChange });
  };
}
export function minAreaChange(minArea: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, minArea }));
    dispatch({ payload: minArea, type: EFilterActionTypes.MinAreaChange });
  };
}
export function maxAreaChange(maxArea: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, maxArea }));
    dispatch({ payload: maxArea, type: EFilterActionTypes.MaxAreaChange });
  };
}
export function deadlineChange(deadline: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, deadline }));
    dispatch({ payload: deadline, type: EFilterActionTypes.DeadlineChange });
  };
}
export function readyApartmentsChange(readyApartments: boolean): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, readyApartments }));
    dispatch({ payload: readyApartments, type: EFilterActionTypes.ReadyApartmentChange });
  };
}
export function apartmentsWithDecorationChange(apartmentsWithDecoration: boolean): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, apartmentsWithDecoration }));
    dispatch({ payload: apartmentsWithDecoration, type: EFilterActionTypes.ApartmentWithDecorationChange });
  };
}
export function seriaPlusChange(seriaPlus: boolean): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, seriaPlus }));
    dispatch({ payload: seriaPlus, type: EFilterActionTypes.SeriaPlusChange });
  };
}
